import React, { useState, useEffect } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { db } from "../firebase";
import Box from "@mui/material/Box";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore/lite";

import {
  Card,
  Button,
  Typography,
  Container,
  useMediaQuery,
} from "@mui/material";

import { useParams } from "react-router-dom";
import { 
  AudioWrapper, 
  BEGIN_TEST,
  VOCAB_TEST,
  VOCABULARY,
  APT_TEST,
  COMPREHENSIVE_TEST,
  EMOTIONAL_INTELLIGENCE_TEST,
  CALL_CENTER_KNOWLEDGE_TEST,
  CUSTOMER_SERVICE_TEST,
  SALES_TEST,
  ATTENTION_TO_DETAIL_TEST, 
  TECH_SUPPORT,
  SALES_RETENTION_TEST,
  ALTICE_QUESTIONS_TEST,
  RETENTION_LISTENING_TEST
} from "./helper";
import Banner from "./Banner";
import MySpinner from "./MySpinner";
import SoftBox from "./SoftBox";
import SoftTypography from "./SoftTypography";
import SoftButton from "./SoftButton";
import { RotatingLines } from "react-loader-spinner";

const VocabCard = ({ vocab }) => {
  const hasSubQuestions = Array.isArray(vocab.questions);

  return (
    <SoftBox mb={1}>
      {hasSubQuestions && vocab.paragraph_text && (
        <SoftBox mb={1}>
          <SoftTypography
            variant="body2"
            color="dark"
            style={{ marginBottom: "20px", marginTop: "20px" }}
            dangerouslySetInnerHTML={{ __html: vocab.paragraph_text }}
          />
        </SoftBox>
      )}

      {/* Main question card (only if not having sub-questions) */}
      {!hasSubQuestions && (
        <Card variant="outlined" mb={2}>
          <SoftBox lineHeight={0}>
            <SoftBox mb={1} pl={1} bgColor="grey-100">
              <SoftTypography
                variant="h6"
                fontWeight="medium"
                color="dark"
                style={{ paddingBottom: "8px" }}
              >
                {vocab.question}
              </SoftTypography>
            </SoftBox>
            <SoftBox mt={1} pl={1}>
              <SoftTypography variant="body2" fontWeight="medium" color="text">
                Answered: &nbsp;&nbsp;&nbsp; {Array.isArray(vocab.answer) ? vocab.answer.join(', ') : vocab.answer}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </Card>
      )}

      {/* Sub-questions if any */}
      {hasSubQuestions &&
        vocab.questions.map((sub, index) => (
          <SoftBox mb={1} key={index}>
            <Card variant="outlined">
              <SoftBox lineHeight={0}>
                <SoftBox mb={1} pl={1} bgColor="grey-100">
                  <SoftTypography
                    variant="h6"
                    fontWeight="medium"
                    color="dark"
                    style={{ paddingBottom: "8px" }}
                  >
                    {sub.question}
                  </SoftTypography>
                </SoftBox>
                <SoftBox mt={1} pl={1}>
                  <SoftTypography variant="body2" fontWeight="medium" color="text">
                    Answered: &nbsp;&nbsp;&nbsp; {Array.isArray(sub.answer) ? sub.answer.join(', ') : sub.answer}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            </Card>
          </SoftBox>
        ))}
    </SoftBox>
  );
};

export default function Review() {
  const [assessment, setAssessment] = useState();
  const [sectionKeyMapping, setSectionKeyMapping] = useState([]);
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState();
  const [audioUrl, setAudioUrl] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const [listeningTestArray, setListeningTestArray] = useState([]);
  const [testStatus, setTestStatus] = useState(null);
  const [success, setSuccess] = useState(false);
  const [audioUrls, setAudioUrls] = useState({});
  const [loadingAudios, setLoadingAudios] = useState(true);
  const [isAudioLoading, setIsAudioLoading] = useState(true);

  let { q } = useParams();

  const REVIEW_RECORDING = "Review Recording";
  const REVIEW_QUESTIONS = "Review Questions";
  const REVIEW_LISTENING = "Review Listening";
  const steps = [REVIEW_RECORDING, REVIEW_QUESTIONS, REVIEW_LISTENING];
  const reviewSteps = [
    VOCAB_TEST,
    VOCABULARY,
    APT_TEST,
    COMPREHENSIVE_TEST,
    EMOTIONAL_INTELLIGENCE_TEST,
    CALL_CENTER_KNOWLEDGE_TEST,
    CUSTOMER_SERVICE_TEST,
    SALES_TEST,
    SALES_RETENTION_TEST,
    ATTENTION_TO_DETAIL_TEST,
    TECH_SUPPORT,
    ALTICE_QUESTIONS_TEST
  ];
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  useEffect(() => {
    setIsLoading(true);
    const userRef = doc(db, "users", q);
    const assessmentRef = doc(db, "assessments", q);

    getDoc(userRef)
      .then(async (docSnapshot) => {
        if (docSnapshot.exists()) {
          const userData = docSnapshot.data();
          userData.id = docSnapshot.id;

          const q1 = query(
            collection(db, "assessments"),
            where("userId", "==", docSnapshot.id),
            orderBy("createdAt", "desc"),
            limit(1)
          );
          const querySnapshot = await getDocs(q1);
          if (!querySnapshot.empty) {
            const assessment = querySnapshot.docs[0].data();
            assessment.uid = querySnapshot.docs[0].id;
            setAssessment(assessment);

            setAudioUrl(assessment.audioUrl);
            fetchAllAudioUrls(assessment);

            setIsLoading(false);
            if (assessment.currentStep) {
              setTestStatus(assessment.currentStep);
            }
            if (assessment.listeningAnswer) {
              const groupedAnswers = assessment.listeningAnswer.reduce(
                (acc, curr) => {
                  if (!acc[curr.audioFile]) {
                    acc[curr.audioFile] = [];
                  }
                  acc[curr.audioFile].push(curr);
                  return acc;
                },
                {}
              );
              const groupedAnswersArray = Object.entries(groupedAnswers).map(
                ([audioFile, answers]) => ({
                  audioFile,
                  answers,
                })
              );

              setListeningTestArray(groupedAnswersArray);
            }

            // const assessmentArray = querySnapshot.docs.map((doc) => {
            //   const assessment = doc.data();
            //   assessment.uid = doc.id;
            //   return assessment;
            // });
            // setAssessments(assessmentArray);
          }

          console.log(userData);
          setUser(userData);
        } else {
          console.log("Document not found!");
          // redirect back to previous page here
        }
      })
      .catch((error) => {
        console.error("Error getting document: ", error);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  }, [q]);

  useEffect(() => {
    if (assessment) {
      const updatedMapping = [
        { key: "Vocabulary", value: assessment.vocabtext || assessment.Vocabulary || [], score: assessment.vocabScore || 0},
        { key: "aptitude", value: assessment.aptitude || [], score: assessment.aptitude_score || 0},
        { key: "sales_retention", value: assessment.sales_retention || [], score: assessment.sales_retention_score || 0},
        { key: "comprehensive", value: assessment.comprehensive || [], score: assessment.comprehensive_score || 0},
        { key: "emotional_intelligence", value: assessment.emotional_intelligence || [], score: assessment.ei_score || 0},
        { key: "call_center_knowledge", value: assessment.call_center_knowledge || [], score: assessment.cck_score || 0},
        { key: "customer_service", value: assessment.customer_service || [], score: assessment.cs_score || 0},
        { key: "tech_support", value: assessment.tech_support || [], score: assessment.ts_score || 0},
        { key: "sales", value: assessment.sales || [], score: assessment.sales_score || 0},
        { key: "attention", value: assessment.attention || [], score: assessment.attention_score || 0},
        { key: "altice_question", value: assessment.altice_question || [], score: assessment.altice_question_score || 0},
        { key: "listening", value: assessment.listening || [], score: assessment.listening_score || 0},
        { key: "retention_listening", value: assessment.retention_listening || [], score: assessment.retention_listening_score || 0},
      ];
      setSectionKeyMapping(updatedMapping);
    }
  }, [assessment]);

  useEffect(() => {
    if (assessment && audioUrls) {
      const timeout = setTimeout(() => setIsAudioLoading(false), 1000);
      return () => clearTimeout(timeout);
    }
  }, [assessment, audioUrls]);

  useEffect(() => {
    const hasSingleAudio = !!audioUrls?.audio_url;
    const hasOldAudioUrl = !!assessment?.audioUrl;
  
    if (hasSingleAudio || hasOldAudioUrl) {
      setLoadingAudios(false);
    }
  }, [audioUrls, assessment]);

  const section_header = [
    { key: "Vocabulary", value: "Vocabulary and Grammar" },
    { key: "aptitude", value: "Apptitude w/Technical" },
    { key: "comprehensive", value: "Comprehension" },
    { key: "emotional_intelligence", value: "Emotional Intelligence" },
    { key: "call_center_knowledge", value: "Call Center Knowledge" },
    { key: "customer_service", value: "Customer Service" },
    { key: "sales", value: "Sales" },
    { key: "attention", value: "Attention to Detail" },
    { key: "tech_support", value: "Technical Proficiency" },
    { key: "sales_retention", value: "Sales & Retention" },
    { key: "listening", value: "Listening" },
    { key: "retention_listening", value: "Retention Listening" },
    { key: "altice_question", value: "Altice Questions" },
  ];
  
  const [collapsedSections, setCollapsedSections] = useState(
    reviewSteps.reduce((acc, section) => {
      acc[section] = section !== "Vocabulary"; // Vocabulary section open by default
      return acc;
    }, {})
  );
  
  // Toggle collapse state for a section
  const toggleCollapse = (section) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const getLoader = () => (
    <RotatingLines
      strokeColor="black"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  );

  const fetchSignedUrl = async (filename) => {
    try {
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/get_signed_url?filename=${filename}`;
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await fetch(apiUrl, options);
      const data = await response.json();
      return data.signed_url || null; // Return signed URL or null if missing
    } catch (error) {
      console.error('Error fetching signed URL:', error);
      return null;
    }
  };

  const fetchAllAudioUrls = async (assessment) => {
    const audioFields = [
      "audio_url"
    ];
    // Fetch signed URLs for all existing audio fields
    const urlPromises = audioFields.map(async (field) => {
      if (assessment[field]) {
        const signedUrl = await fetchSignedUrl(assessment[field]);
        return { [field]: signedUrl };
      }
      return null;
    });
    // Resolve all fetches and update the state with valid URLs
    const results = await Promise.all(urlPromises);
    const signedUrls = results.reduce((acc, curr) => (curr ? { ...acc, ...curr } : acc), {});
    setAudioUrls(signedUrls);
  };

  const fetchAndClear = async (assessment) => {
    setAudioUrls({});
    const newAudioUrls = await fetchAllAudioUrls(assessment);
  };

  const renderStep2 = () => {
    return (
      // <Box sx={{ width: "100%", overflowX: "auto" }}>
      <div>
        <div>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{
              maxWidth: "100%",
              display: "flex",
              my: 4,
              // "& .MuiStepLabel-label": { fontSize: "2rem" },
              "& .MuiStepIcon-root": { width: "0.8em", height: "0.8em" },
              connector: {
                lineHeight: 1.6,
                "@media (min-width: 600px)": {
                  lineHeight: 1,
                },
              },
            }}
            // sx={{ "& .MuiStep-root": { paddingLeft: 0, paddingRight: 0 } }}
          >
            {steps.map((label, index) => {
              return (
                <Step key={label}>
                  {/* <StepLabel sx={{ fontSize: "12px", maxWidth: "100px" }}>{label}</StepLabel> */}
                  <StepLabel
                    sx={{
                      "& .MuiStepLabel-label": {
                        lineHeight: isMobile ? 1.4 : 1.6,
                        fontSize: isMobile ? 14 : 16,
                        height: "20px",
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <Box sx={{ flex: "1 1 auto" }} />
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            </>
          ) : (
            <>
              {/* <Typography sx={{ mt: 2, mb: 1 }}>Step {activeStep + 1}</Typography> */}

              {renderStep()}
              {assessment
                ? console.log(
                    "What is activeStep and currentSteps",
                    activeStep,
                    assessment.currentStep
                  )
                : null}

              {testStatus && assessment.currentStep !== BEGIN_TEST && (
                <Container
                  sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    width: "auto",
                    // opacity: 0.8,
                    color: "white",
                    height: "3rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 1rem",
                    boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.25)",
                    position: "fixed",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 999,
                    // margin: "0 1rem 1rem",
                    // marginBottom: "1rem",
                  }}
                >
                   {activeStep === 0 ? null : (
                  <SoftButton
                    color="gt_primary"
                    variant="text"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    Back
                  </SoftButton>)}

                  <Box sx={{ flexGrow: 1 }} />
                  {activeStep === steps.length - 1 ? null : (
                    <SoftButton
                      color="gt_primary"
                      variant="text"
                      onClick={handleNext}
                    >
                      Next
                    </SoftButton>
                  )}
                </Container>
              )}
            </>
          )}
        </div>
      </div>
    );
  };
  const renderStep = () => {
    if (!assessment) return <></>;

    switch (steps[activeStep]) {
      case REVIEW_RECORDING: {

        if (!assessment || (!assessment.audioUrl && !audioUrls) || loadingAudios) {
          return (
            <SoftBox display="flex" justifyContent="center" alignItems="center" py={5} width="30px" height="30px" margin="auto">
              {getLoader()}
            </SoftBox>
          );
        }

        let filteredAudioUrls = [];
        if (assessment?.audioUrl) {
          filteredAudioUrls = [assessment.audioUrl];
        } else if (audioUrls?.audio_url) {
          filteredAudioUrls = [audioUrls.audio_url];
        }
      
        return (
          <Container>
            <SoftBox pt={1} pb={2}>
              <SoftBox pt={0}>
                <SoftTypography variant="body2" fontWeight="bold">
                  Recording
                </SoftTypography>
              </SoftBox>
              <Card variant="outlined">
                {filteredAudioUrls.length > 0 && (
                  <SoftBox pt={3} px={2}>
                    <SoftTypography
                      variant="h5"
                      fontWeight="medium"
                      mt={1}
                      mb={2}
                    >
                      Your recording transcribe
                    </SoftTypography>
                    {filteredAudioUrls.map((url, index) => (
                      <AudioWrapper
                        key={index}
                        style={{ marginTop: "5px", marginBottom: "5px" }}
                      >
                        <audio controls src={url}></audio>
                      </AudioWrapper>
                    ))}
                  </SoftBox>
                )}
                <SoftBox pt={3} px={2} mb={3}>
                  <SoftTypography variant="h6" fontWeight="medium">
                    {assessment.transcribe}
                  </SoftTypography>
                </SoftBox>
              </Card>
            </SoftBox>
            <SoftBox pb={5} />
          </Container>
        );
      }      
      case REVIEW_QUESTIONS:
        return (
          <Container style={{marginBottom: "40px"}}>
            {reviewSteps.map((label) => {
              const sectionHeader =
                section_header.find((section) => section.key === label)?.value || "Unknown Section";
              const section = sectionKeyMapping.find((section) => section.key === label);
              const sectionData = section?.value || [];
              const sectionScore = section?.score || null;
              const isCollapsed = collapsedSections[label];
              return (
                sectionScore &&
                <SoftBox pt={2} pb={4} key={label}>
                  {/* Collapsible Section Header */}
                  <SoftTypography
                    variant="body2"
                    fontWeight="bold"
                    color="dark"
                    onClick={() => toggleCollapse(label)}
                    style={{ cursor: "pointer" }}
                  >
                    {sectionHeader} {isCollapsed ? "▼" : "▲"}
                  </SoftTypography>
        
                  {/* Collapsible Section Content */}
                  {!isCollapsed && (
                    <SoftBox pt={1}>
                      {sectionData.length > 0 ? (
                        sectionData.map((vocab, index) => <VocabCard key={index} vocab={vocab} />)
                      ) : (
                        <SoftTypography variant="h6" fontWeight="medium" color="dark">
                          No answers found for this section.
                        </SoftTypography>
                      )}
                    </SoftBox>
                  )}
                </SoftBox>
              );
            })}
          </Container>
        );
      case REVIEW_LISTENING:

        if (!assessment) return;

        const listeningSections = [];
        if (assessment.listening) listeningSections.push("listening");
        if (assessment.retention_listening) listeningSections.push("retention_listening");
      
        const relevantSections = listeningSections
          .map((key) => sectionKeyMapping.find((section) => section.key === key))
          .filter(Boolean);

        return (
          <Container>
            <SoftBox pt={1} pb={2}>
              {relevantSections.map((section) => {
                const sectionHeader =
                  section_header.find((s) => s.key === section.key)?.value || "Unknown Section";
                const sectionData = section?.value || [];
                const sectionScore = section?.score || null;
                const sectionTime = section?.time || null;
                const isCollapsed = collapsedSections[section.key];

                return (
                  <SoftBox pt={2} pb={4} key={section.key}>
                    <SoftTypography
                      variant="body2"
                      fontWeight="bold"
                      color="dark"
                      onClick={() => toggleCollapse(section.key)}
                      style={{ cursor: "pointer" }}
                    >
                      {sectionHeader} {isCollapsed ? "▼" : "▲"}
                    </SoftTypography>
        
                    {!isCollapsed && (
                      <SoftBox pt={1}>
                        {sectionData.length > 0 ? (
                          sectionData.map((audioObj, index) => (
                            <SoftBox key={index} pt={3}>
                              {audioObj.audio_url && (
                                <AudioWrapper
                                  key={index}
                                  style={{ backgroundColor: "white", padding: "25px 5px 25px 20px" }}
                                >
                                  <audio controls src={process.env.REACT_APP_STATIC_REPO + audioObj.audio_url} />
                                </AudioWrapper>
                              )}
        
                              <SoftBox pt={2}>
                                {audioObj.questions.map((question, qIndex) => {
                                  const card = (
                                    <VocabCard
                                      key={qIndex}
                                      vocab={question}
                                    />
                                  );
                                  return card;
                                })}
                              </SoftBox>
                            </SoftBox>
                          ))
                        ) : (
                          <SoftTypography variant="h6" fontWeight="medium" color="dark">
                            No answers found for this section.
                          </SoftTypography>
                        )}
                      </SoftBox>
                    )}
                  </SoftBox>
                );
              })}
            </SoftBox>
            <SoftBox pb={5} />
          </Container>
        );
      default:
        return null;
    }
  };

  if (isLoading) {
    return <MySpinner />;
  }

  return (
    <div>
      <Banner showBackButton={true} />
      {success && (
        <div style={{ textAlign: "center", margin: "10px" }}>Email Sent</div>
      )}
      {renderStep2()}
    </div>
  );
}
